<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-partners-openforge-hero-section />
  <!-- Benefits -->
  <app-partners-openforge-benefits-section />
  <!-- Services -->
  <app-partners-openforge-services-section />
  <!-- FAQ -->
  <app-partners-openforge-faq-section />
  <!-- CTA -->
  <app-partners-openforge-cta-section />
</div>
